import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  createAdCreativeLoading: false,
  error: null,
  adCreativesId: [],
}

export const facebookAdCreativesSlice = createSlice({
  name: "facebookAdCreatives",
  initialState,
  reducers: {
    createAdCreativeLoading: (state) => {
      state.createAdCreativeLoading = true
      state.error = null
    },
    createAdCreativeSuccess: (state, action) => {
      state.createAdCreativeLoading = false
      state.error = null
      state.adCreativesId = [...state.adCreativesId, { id: action.payload.id }]
    },
    createAdCreativeFailure: (state, action) => {
      state.createAdCreativeLoading = false
      state.error = action.payload
    },
  },
})

export const {
  createAdCreativeLoading,
  createAdCreativeSuccess,
  createAdCreativeFailure,
} = facebookAdCreativesSlice.actions

export default facebookAdCreativesSlice.reducer
